/*!
 * Copyright 2023 Quisitive Technologies, LLC. All rights reserved.
 */
import React, { useEffect } from 'react';

import { get, values } from 'lodash';
import Element from '../../../../components/element';
import Button from '../../../../components/Button';
import Flex from '../../../../components/flex';
import Text from '../../../../components/text';
import NoData from '../../NoData';
import { create, updateData } from '../../Chart/DistributionChart/chart';

const Balance = ({ healthReportData }) => {
  useEffect(() => {
    const newBalanceList = values(healthReportData.balance);
    newBalanceList.map(each => {
      if (each.display_label) {
        const data = { ...each, section: 'balance', chartVal: each.value };
        const settings = {
          el: each.display_label.replace(/ /g, '_').replace(/[^a-zA-Z ]/g, ''),
          margin: {
            top: 0,
            right: 0,
            bottom: 0,
            left: 0
          }
        };
        create(settings);
        updateData(data);
      }
    });
  }, []);
  return (
    <Element>
      {get(healthReportData, 'balance.score.value') === null ? (
        <NoData />
      ) : (
        <Element>
          <Flex align="center" marginTop="35px">
            <Element width="22%" marginRight="50px">
              <Text family="GTAM" size="14px" color="#222222">
                Balance is the ability to orient the body in space and maintain
                an upright posture under both static and dynamic conditions.
              </Text>
              <Text family="GTAM" size="14px" color="#222222">
                Three systems contribute to balance performance:
              </Text>
            </Element>
            <Element width="180px" marginRight="85px">
              <Element>
                <Text family="GTAM" size="21px" color="#222222">
                  Overall Score
                </Text>
              </Element>
              <Flex>
                <Element marginRight="40px">
                  <Text family="GTAM" size="32px" color="#222222">
                    {/* {get(healthReportData, 'balance.score.value')} */}
                    {Math.round(
                      Number(get(healthReportData, 'balance.score.value'))
                    ) || '0'}
                  </Text>
                  <Text family="GTAR" size="14px" color="#959595">
                    Score
                  </Text>
                </Element>
                <Element>
                  <Text family="GTAM" size="32px" color="#222222">
                    {/* {Number(
                      get(healthReportData, 'balance.score.percentile')
                    ).toFixed(2)}
                    % */}
                    {Math.round(
                      Number(get(healthReportData, 'balance.score.percentile'))
                    ) || '0'}
                    %
                  </Text>
                  <Text family="GTAR" size="14px" color="#959595">
                    Percentile
                  </Text>
                </Element>
              </Flex>
            </Element>
            <div
              id={get(healthReportData, 'balance.score.display_label')
                .replace(/ /g, '_')
                .replace(/[^a-zA-Z ]/g, '')}
              style={{ width: '50%', marginLeft: '-56px' }}
            ></div>
          </Flex>
          <Flex>
            <Element width="22%" marginRight="70px">
              <Element marginTop="25px">
                <Text family="GTAR" size="14px" color="#222222">
                  <strong>The Vestibular System</strong> in the inner ear senses
                  gravity, and linear and rotational movement.
                </Text>
              </Element>
              <Element marginTop="25px">
                <Text family="GTAR" size="14px" color="#222222">
                  <strong>The Visual System</strong> provides information about
                  the body’s orientation and motion in space.
                </Text>
              </Element>
              <Element marginTop="25px">
                <Text family="GTAR" size="14px" color="#222222">
                  <strong>The Proprioceptive System</strong>— a network of
                  receptors in the muscles, joints, and skin — senses how the
                  body and limbs are positioned relative to one another.
                </Text>
              </Element>
              <Element marginTop="25px">
                <Text family="GTAR" size="14px" color="#222222">
                  Over half of accidental deaths among the elderly are the
                  result of balance-related falls.
                </Text>
              </Element>
            </Element>
            <Element width="80%" marginTop="105px">
              <Flex align="center">
                <Element width="50%" marginRight="175px">
                  <Text
                    family="GTAM"
                    size="16px"
                    color="#222222"
                    marginBottom="0px"
                  >
                    Feet Together
                  </Text>
                  <Text
                    family="GTAM"
                    size="16px"
                    color="#222222"
                    marginTop="0px"
                  >
                    (EO)
                  </Text>
                </Element>
                <Element marginRight="70px">
                  <Text
                    family="GTAM"
                    size="24px"
                    color="#222222"
                    marginBottom="0px"
                  >
                    {/* {get(healthReportData, 'balance.feet_together_eo.value')} */}
                    {Math.round(
                      Number(
                        get(healthReportData, 'balance.feet_together_eo.value')
                      )
                    ) || '0'}
                  </Text>
                  <Element marginTop="3px">
                    <Text
                      family="GTAR"
                      size="14px"
                      color="#959595"
                      marginTop="0px"
                    >
                      Score
                    </Text>
                  </Element>
                </Element>
                <div
                  id={get(
                    healthReportData,
                    'balance.feet_together_eo.display_label'
                  )
                    .replace(/ /g, '_')
                    .replace(/[^a-zA-Z ]/g, '')}
                  style={{ width: '86%' }}
                ></div>
              </Flex>
              <Flex align="center" marginTop="80px">
                <Element width="50%" marginRight="175px">
                  <Text
                    family="GTAM"
                    size="16px"
                    color="#222222"
                    marginBottom="0px"
                  >
                    Feet Together
                  </Text>
                  <Text
                    family="GTAM"
                    size="16px"
                    color="#222222"
                    marginTop="0px"
                  >
                    (EC)
                  </Text>
                </Element>
                <Element marginRight="70px">
                  <Text
                    family="GTAM"
                    size="24px"
                    color="#222222"
                    marginBottom="0px"
                  >
                    {/* {get(healthReportData, 'balance.feet_together_ec.value')} */}
                    {Math.round(
                      Number(
                        get(healthReportData, 'balance.feet_together_ec.value')
                      )
                    ) || '0'}
                  </Text>
                  <Element marginTop="3px">
                    <Text
                      family="GTAR"
                      size="14px"
                      color="#959595"
                      marginTop="0px"
                    >
                      Score
                    </Text>
                  </Element>
                </Element>
                <div
                  id={get(
                    healthReportData,
                    'balance.feet_together_ec.display_label'
                  )
                    .replace(/ /g, '_')
                    .replace(/[^a-zA-Z ]/g, '')}
                  style={{ width: '86%' }}
                ></div>
              </Flex>
              <Flex align="center" marginTop="80px">
                <Element width="50%" marginRight="175px">
                  <Text
                    family="GTAM"
                    size="16px"
                    color="#222222"
                    marginBottom="0px"
                  >
                    Feet Together
                  </Text>
                  <Text
                    family="GTAM"
                    size="16px"
                    color="#222222"
                    marginTop="0px"
                  >
                    (EO/F)
                  </Text>
                </Element>
                <Element marginRight="70px">
                  <Text
                    family="GTAM"
                    size="24px"
                    color="#222222"
                    marginBottom="0px"
                  >
                    {/* {get(healthReportData, 'balance.feet_together_eof.value')} */}
                    {Math.round(
                      Number(
                        get(healthReportData, 'balance.feet_together_eof.value')
                      )
                    ) || '0'}
                  </Text>
                  <Element marginTop="3px">
                    <Text
                      family="GTAR"
                      size="14px"
                      color="#959595"
                      marginTop="0px"
                    >
                      Score
                    </Text>
                  </Element>
                </Element>
                <div
                  id={get(
                    healthReportData,
                    'balance.feet_together_eof.display_label'
                  )
                    .replace(/ /g, '_')
                    .replace(/[^a-zA-Z ]/g, '')}
                  style={{ width: '86%' }}
                ></div>
              </Flex>
              <Flex align="center" marginTop="80px">
                <Element width="50%" marginRight="175px">
                  <Text
                    family="GTAM"
                    size="16px"
                    color="#222222"
                    marginBottom="0px"
                  >
                    Feet Together
                  </Text>
                  <Text
                    family="GTAM"
                    size="16px"
                    color="#222222"
                    marginTop="0px"
                  >
                    (EC/F)
                  </Text>
                </Element>
                <Element marginRight="70px">
                  <Text
                    family="GTAM"
                    size="24px"
                    color="#222222"
                    marginBottom="0px"
                  >
                    {/* {get(healthReportData, 'balance.feet_together_ecf.value')} */}
                    {Math.round(
                      Number(
                        get(healthReportData, 'balance.feet_together_ecf.value')
                      )
                    ) || '0'}
                  </Text>
                  <Element marginTop="3px">
                    <Text
                      family="GTAR"
                      size="14px"
                      color="#959595"
                      marginTop="0px"
                    >
                      Score
                    </Text>
                  </Element>
                </Element>
                <div
                  id={get(
                    healthReportData,
                    'balance.feet_together_ecf.display_label'
                  )
                    .replace(/ /g, '_')
                    .replace(/[^a-zA-Z ]/g, '')}
                  style={{ width: '86%' }}
                ></div>
              </Flex>
            </Element>
          </Flex>
        </Element>
      )}
    </Element>
  );
};

export default Balance;
